import { lazy } from 'react';
import Loadable from '../layouts/full/shared/loadable/Loadable';
import { Navigate } from 'react-router';
import BankList from 'src/views/apps/bank/BankList';
import {
  BANK_LIST_SK,
  CATEGORY_LIST_SK,
  FINISHED_GOOD_LIST_SK,
  FINISHED_GOOD_VIEW_SK,
  PERMISSION_LIST_SK,
  PRODUCTION_CREATE_SK,
  PRODUCTION_EDIT_SK,
  PRODUCTION_LIST_SK,
  PURCHASE_CREATE_SK,
  PURCHASE_LIST_SK,
  RAW_MATERIAL_LIST_SK,
  RAW_MATERIAL_VIEW_SK,
  ROLE_CREATE_SK,
  ROLE_EDIT_SK,
  ROLE_LIST_SK,
  SHOP_LIST_SK,
  SUPPLIER_LIST_SK,
  UOM_CONVERSION_LIST_SK,
  UOM_LIST_SK,
  USER_LIST_SK,
  WAREHOUSE_LIST_SK,
  WAREHOUSE_CONSUMPTION_LIST_SK,
  WAREHOUSE_CONSUMPTION_CREATE_SK,
  WAREHOUSE_CONSUMPTION_EDIT_SK,
  WAREHOUSE_CONSUMPTION_VIEW_SK,
  PURCHASE_EDIT_SK,
  PURCHASE_VIEW_SK,
  INVENTORY_LIST_SK,
  INVENTORY_VIEW_SK,
  ORDER_LIST_SK,
  SALE_LIST_SK,
  SALE_VIEW_SK,
  STOCK_RETURN_LIST_SK,
  BRAND_LIST_SK,
  REGION_LIST_SK,
  ORDER_CREATE_SK,
  ORDER_REPORT_LIST_SK,
  SALE_REPORT_LIST_SK,
  PRODUCTION_ORDER_LIST_SK,
  PRODUCTION_ORDER_CREATE_SK,
  PRODUCTION_ORDER_EDIT_SK,
  PRODUCTION_ORDER_VIEW_SK,
  BILL_LIST_SK,
  BILL_CREATE_SK,
  BILL_VIEW_SK,
  BILL_EDIT_SK,
  PAYMENT_LIST_SK,
  PAYMENT_CREATE_SK,
  PAYMENT_VIEW_SK,
  PAYMENT_EDIT_SK,
  PURCHASE_REPORT_LIST_SK,
  BILL_REPORT_LIST_SK,
  PAYMENT_REPORT_LIST_SK,
  STOCK_MOVEMENT_LIST_SK,
  INTERNAL_TRANSFER_LIST_SK,
  INTERNAL_TRANSFER_CREATE_SK,
  INTERNAL_TRANSFER_EDIT_SK,
  INTERNAL_TRANSFER_VIEW_SK,
  STOCK_REQUEST_LIST_SK,
  STOCK_REQUEST_CREATE_SK,
  STOCK_REQUEST_EDIT_SK,
  STOCK_REQUEST_VIEW_SK,
  WAREHOUSE_ORDER_LIST_SK,
  WAREHOUSE_ORDER_CREATE_SK,
  WAREHOUSE_ORDER_UPDATE_SK,
  WAREHOUSE_ORDER_VIEW_SK,
  STOCK_MOVEMENT_REPORT_LIST_SK,
  DAILY_INVENTORY_VALUATION_REPORT_LIST_SK,
  DAILY_STOCK_SUMMARY_REPORT_LIST_SK,
  STOCK_ORDER_SUMMARY_REPORT_LIST_SK,
  ESTIMATED_PRODUCTION_BALANCE_REPORT_LIST_SK,
  PURCHASE_HISTORY_LIST_SK,
  STOCK_ADJUSTMENT_LIST_SK,
  EXPENSE_LIST_SK,
  EXPENSE_HEADER_LIST_SK,
  EXPENSE_SUBHEADER_LIST_SK,
  CONSUMPTION_TYPE_LIST_SK,
  ORDER_VIEW_SK,
  ORDER_ITEM_EDIT_SK,
  PAR_LEVEL_LIST_SK,
} from 'src/lib/constants';
import { PRICE_CHANGE_SK } from 'src/lib/constants/permissions';

/* ***Dashboard**** */
const Dashboard = Loadable(lazy(() => import('../views/dashboard/Modern')));

/* ***Permission**** */
const PermissionList = Loadable(lazy(() => import('../views/apps/permission/PermissionList')));
const PermissionDenied = Loadable(lazy(() => import('../views/apps/permission/PermissionDenied')));

/* ***Role**** */
const RoleList = Loadable(lazy(() => import('../views/apps/role/RoleList')));
const CreateRole = Loadable(lazy(() => import('../views/apps/role/CreateRole')));
const EditRole = Loadable(lazy(() => import('../views/apps/role/Role')));

/* ***UOM**** */
const UomList = Loadable(lazy(() => import('../views/apps/uom/UomList')));
const UomConversionList = Loadable(lazy(() => import('../views/apps/uom-conversion/UomConversionList')));

/* ***Category**** */
const CategoryList = Loadable(lazy(() => import('../views/apps/category/CategoryList')))

/* ***Consumption Type**** */
const ConsumptionTypeList = Loadable(lazy(() => import('../views/apps/consumption-type/ConsumptionTypeList')))

/* ***Category**** */
const RawMaterialList = Loadable(lazy(() => import('../views/apps/raw-material/RawMaterialList')))
const RawMaterialDetails = Loadable(lazy(() => import('../views/apps/raw-material/RawMaterialDetails')))
const FinishedGoodList = Loadable(lazy(() => import('../views/apps/finished-good/FinishedGoodList')))
const FinishedGoodDetails = Loadable(lazy(() => import('../views/apps/finished-good/FinishedGoodDetails')))
const ProductionList = Loadable(lazy(() => import('../views/apps/production/ProductionList')))
const CreateProduction = Loadable(lazy(() => import('../views/apps/production/CreateProduction')))
const EditProduction = Loadable(lazy(() => import('../views/apps/production/EditProduction')))

/* ***Production Order**** */
const ProductionOrderCreateUpdate = Loadable(lazy(() => import('../views/apps/production-order/ProductionOrderCreateUpdate')))
const ProductionOrderList = Loadable(lazy(() => import('../views/apps/production-order/ProductionOrderList')))
const ProductionOrderDetail = Loadable(lazy(() => import('../views/apps/production-order/ProductionOrderDetail')))

/* ***Warehouses**** */
const WarehouseList = Loadable(lazy(() => import('../views/apps/warehouse/WarehouseList')));
const WarehouseConsumptionList = Loadable(lazy(() => import('../views/apps/warehouse-consumption/WarehouseConsumptionList')));
const WarehouseConsumptionCreate = Loadable(lazy(() => import('../views/apps/warehouse-consumption/WarehouseConsumptionForm')));
const WarehouseConsumptionDetail = Loadable(lazy(() => import('../views/apps/warehouse-consumption/WarehouseConsumptionDetail')));
const ConsumptionItemList = Loadable(lazy(() => import('../views/apps/warehouse-consumption/ConsumptionItemList')));

/* ***Shops**** */
const ShopList = Loadable(lazy(() => import('../views/apps/shop/ShopList')));

/* ***Suppliers**** */
const SupplierList = Loadable(lazy(() => import('../views/apps/supplier/SupplierList')));

/* ***Expense Categories**** */
const ExpenseCategoryList = Loadable(
  lazy(() => import('../views/apps/expense-category/ExpenseCategoryList')),
);

/* ***Expenses**** */
const ExpenseList = Loadable(lazy(() => import('../views/apps/expense/ExpenseList')));
const ExpenseHeaderList = Loadable(lazy(() => import('../views/apps/expense/ExpenseHeaderList')));
const ExpenseSubheaderList = Loadable(lazy(() => import('../views/apps/expense/ExpenseSubheaderList')));

/* ***Users**** */
const UserList = Loadable(lazy(() => import('../views/apps/user/UserList')));

// authentication
const Login = Loadable(lazy(() => import('../views/authentication/auth/Login')));
const ForgotPassword = Loadable(lazy(() => import('../views/authentication/auth/ForgotPassword')));
const Error = Loadable(lazy(() => import('../views/authentication/Error')));
const Maintenance = Loadable(lazy(() => import('../views/authentication/Maintenance')));

/* ***Purchase**** */
const PurchaseList = Loadable(
  lazy(() => import('../views/apps/purchase/PurchaseList')),
);
const CreatePurchase = Loadable(lazy(() => import('../views/apps/purchase/CreatePurchase')));
const PurchaseDetail = Loadable(lazy(() => import('../views/apps/purchase/PurchaseDetail')));

/* ***Bill**** */
const BillList = Loadable(lazy(() => import('../views/apps/bill/BillList')));
const CreateBill = Loadable(lazy(() => import('../views/apps/bill/CreateBill')));
const BillDetail = Loadable(lazy(() => import('../views/apps/bill/BillDetail')));
const PaidBillList = Loadable(lazy(() => import('../views/apps/bill/PaidBillListView')));
const UnpaidBillList = Loadable(lazy(() => import('../views/apps/bill/UnpaidBillListView')));

/* ***Payment*** */
const PaymentList = Loadable(lazy(() => import('../views/apps/payment/PaymentList')));
const CreatePayment = Loadable(lazy(() => import('../views/apps/payment/CreatePayment')));
const BulkPayment = Loadable(lazy(() => import('../views/apps/payment/BulkPayment')));
const PaymentDetail = Loadable(lazy(() => import('../views/apps/payment/PaymentDetail')));
const SinglePayment = Loadable(lazy(() => import('../views/apps/payment/SinglePayment')));

// inventory 
const InventoryList = Loadable(lazy(() => import('../views/apps/inventory/InventoryList')));
const InventoryHistory = Loadable(lazy(() => import('../views/apps/inventory/InventoryHistory')));
const StockListView = Loadable(lazy(() => import('../views/apps/inventory/StockListView')));
const InternalTransferList = Loadable(lazy(() => import('../views/apps/inventory/internal-transfer/InternalTransferList')));
const CreateUpdateInternalTransfer = Loadable(lazy(() => import('../views/apps/inventory/internal-transfer/CreateUpdateInternalTransfer')));
const InternalTransferDetail = Loadable(lazy(() => import('../views/apps/inventory/internal-transfer/InternalTransferDetail')));
const StockRequestList = Loadable(lazy(() => import('../views/apps/inventory/stock-request/StockRequestList')));
const CreateUpdateStockRequest = Loadable(lazy(() => import('../views/apps/inventory/stock-request/CreateUpdateStockRequest')));
const StockRequestDetail = Loadable(lazy(() => import('../views/apps/inventory/stock-request/StockRequestDetail')));
const WarehouseOrderList = Loadable(lazy(() => import('../views/apps/warehouse-ops/WarehouseOrderList')));
const CreateUpdateWarehouseOrder = Loadable(lazy(() => import('../views/apps/warehouse-ops/CreateUpdateWarehouseOrder')));
const WarehouseOrderDetail = Loadable(lazy(() => import('../views/apps/warehouse-ops/WarehouseOrderDetail')));

// order
const OrderList = Loadable(lazy(() => import('src/views/apps/order/OrderList')));
const OrderDetails = Loadable(lazy(() => import('src/views/apps/order/OrderDetails')));
const SaleList = Loadable(lazy(() => import('src/views/apps/sale/SaleList')));
const SaleDetails = Loadable(lazy(() => import('src/views/apps/sale/SaleDetails')));
const DiscrepancySummaryView = Loadable(lazy(() => import('../views/apps/discrepancies/DiscrepancyListByShop')));
const DiscrepancyList = Loadable(lazy(() => import('../views/apps/discrepancies/DiscrepancyListByShop')));
const BackorderListByShop = Loadable(lazy(() => import('../views/apps/backorders/BackorderListByShop')));
const ShopBalanceListByShopView = Loadable(lazy(() => import('../views/apps/shop-balance/ShopBalanceListByShopView')));

// account setting 
const AccountSetting = Loadable(lazy(() => import('../views/pages/account-setting/AccountSetting')));

const StockReturnList = Loadable(lazy(() => import('../views/apps/stock-return/StockReturnList')));
const StockMovementList = Loadable(lazy(() => import('../views/apps/stock-movement/StockMovementList')));

const SalesReport = Loadable(lazy(() => import('../views/apps/reports/SalesReport')));
const SalesPivotReport = Loadable(lazy(() => import('../views/apps/reports/SalesPivotReport')));
const OrderReport = Loadable(lazy(() => import('../views/apps/reports/OrderReport')));
const OrderPivotReport = Loadable(lazy(() => import('../views/apps/reports/OrderPivotReport')));
const PurchasePivotReport = Loadable(lazy(() => import('../views/apps/reports/PurchasePivotReport')));
const BillsPivotReport = Loadable(lazy(() => import('../views/apps/reports/BillsPivotReport')));
const PaymentsMadeReport = Loadable(lazy(() => import('../views/apps/reports/PaymentsMadeReport')));
const StockMovementPivotReport = Loadable(lazy(() => import('../views/apps/reports/StockMovementPivotReport')));
const OrderFulfillmentStatus = Loadable(lazy(() => import('../components/apps/order/OrderFulfillmentStatus')));
const StockPivotReport = Loadable(lazy(() => import('../views/apps/reports/StockPivotReport')));
const StockOrderSummaryReport = Loadable(lazy(() => import('../views/apps/reports/StockOrderSummaryReport')));
const DailyStockSummaryReport = Loadable(lazy(() => import('../views/apps/reports/DailyStockSummaryReport')));
const DailyInventoryValuationReport = Loadable(lazy(() => import('../views/apps/reports/DailyInventoryValuationReport')));
const EstimatedProductionBalanceReport = Loadable(lazy(() => import('../views/apps/reports/EstimatedProductionBalanceReport')));
const PurchaseHistory = Loadable(lazy(() => import('../views/apps/reports/PurchaseHistory')));

const StockAdjustmentList = Loadable(lazy(() => import('../views/apps/adjustment/AdjustmentList')));
const PriceList = Loadable(lazy(() => import('../views/apps/product/PriceListView')));
const PriceHistory = Loadable(lazy(() => import('../views/apps/product/PriceHistoryView')));
const StandardCostHistory = Loadable(lazy(() => import('../views/apps/product/StandardCostHistoryView')));

const BrandList = Loadable(lazy(() => import('../views/apps/brand/BrandList')));
const RegionList = Loadable(lazy(() => import('../views/apps/region/RegionList')));
const CreateUpdateOrder = Loadable(lazy(() => import('../views/apps/order/CreateUpdateOrder')));
const ParLevelSettingsPage = Loadable(lazy(() => import('../views/apps/shop-product-settings/ParLevelSettingsPage')));
const VersionListPage = Loadable(lazy(() => import('../views/apps/version/VersionListPage')));

export const AUTH_ROUTES = [
  { path: '/auth/login', element: <Login /> },
  { path: '/404', element: <Error /> },

];

export const APP_ROUTES = [
  {
    index: true,
    redirect: '/dashboard',
  },
  {
    path: '/dashboard',
    element: <Dashboard />,
    // Backend has no dashboard permission — intentional authenticated-only.
    permission: null,
  },
  {
    path: '/permissions',
    element: <PermissionList />,
    permission: PERMISSION_LIST_SK,
  },
  {
    path: '/roles',
    element: <RoleList />,
    permission: ROLE_LIST_SK,
  },
  {
    path: '/raw-materials',
    element: <RawMaterialList />,
    permission: RAW_MATERIAL_LIST_SK,
  },
  {
    path: '/finished-goods/:id',
    element: <FinishedGoodDetails />,
    permission: FINISHED_GOOD_VIEW_SK,
  },
  {
    path: '/finished-goods',
    element: <FinishedGoodList />,
    permission: FINISHED_GOOD_LIST_SK,
  },
  {
    path: '/price-list',
    element: <PriceList />,
    permission: PRICE_CHANGE_SK,
    requireProductMasterAccess: true,
  },
  {
    path: '/price-history',
    element: <PriceHistory />,
    permission: PRICE_CHANGE_SK,
    requireProductMasterAccess: true,
  },
  {
    path: '/standard-cost-history',
    element: <StandardCostHistory />,
    permission: PRICE_CHANGE_SK,
    requireProductMasterAccess: true,
  },
  {
    path: '/raw-materials/:id',
    element: <RawMaterialDetails />,
    permission: RAW_MATERIAL_VIEW_SK,
  },
  {
    path: '/productions',
    element: <ProductionList />,
    permission: PRODUCTION_LIST_SK,
  },
  {
    path: '/productions/create',
    element: <CreateProduction />,
    permission: PRODUCTION_CREATE_SK,
  },
  {
    path: '/productions/edit/:id',
    element: <EditProduction />,
    permission: PRODUCTION_EDIT_SK,
  },
  {
    path: '/production-orders',
    element: <ProductionOrderList />,
    permission: PRODUCTION_ORDER_LIST_SK,
    requireYangonAccess: true,
  },
  {
    path: '/production-orders/create',
    element: <ProductionOrderCreateUpdate />,
    permission: PRODUCTION_ORDER_CREATE_SK,
    requireYangonAccess: true,
  },
  {
    path: '/production-orders/edit/:id',
    element: <ProductionOrderCreateUpdate />,
    permission: PRODUCTION_ORDER_EDIT_SK,
    requireYangonAccess: true,
  },
  {
    path: '/production-orders/:id',
    element: <ProductionOrderDetail />,
    permission: PRODUCTION_ORDER_VIEW_SK,
    requireYangonAccess: true,
  },
  {
    path: '/uoms',
    element: <UomList />,
    permission: UOM_LIST_SK,
  },
  {
    path: '/uom-conversions',
    element: <UomConversionList />,
    permission: UOM_CONVERSION_LIST_SK,
  },
  {
    path: '/versions',
    element: <VersionListPage />,
    // Version Control reads are public and writes require authentication only
    // in the current backend contract; no dedicated permission exists.
    permission: null,
  },
  {
    path: '/categories',
    element: <CategoryList />,
    permission: CATEGORY_LIST_SK,
  },
  {
    path: '/consumption-types',
    element: <ConsumptionTypeList />,
    permission: CONSUMPTION_TYPE_LIST_SK,
  },
  {
    path: '/roles/new',
    element: <CreateRole />,
    permission: ROLE_CREATE_SK,
  },
  {
    path: '/roles/edit/:id',
    element: <EditRole />,
    permission: ROLE_EDIT_SK,
  },
  {
    path: '/users',
    element: <UserList />,
    permission: USER_LIST_SK,
  },
  {
    path: '/warehouses',
    element: <WarehouseList />,
    permission: WAREHOUSE_LIST_SK,
  },
  {
    path: '/warehouse-consumptions',
    element: <WarehouseConsumptionList />,
    permission: WAREHOUSE_CONSUMPTION_LIST_SK,
  },
  {
    path: '/warehouse-consumptions/form',
    element: <WarehouseConsumptionCreate />,
    permission: WAREHOUSE_CONSUMPTION_CREATE_SK,
  },
  {
    path: '/warehouse-consumptions/form/:id',
    element: <WarehouseConsumptionCreate />,
    permission: WAREHOUSE_CONSUMPTION_EDIT_SK,
  },
  {
    path: '/warehouse-consumptions/:id',
    element: <WarehouseConsumptionDetail />,
    permission: WAREHOUSE_CONSUMPTION_VIEW_SK,
  },
  {
    path: '/consumption-items',
    element: <ConsumptionItemList />,
    permission: WAREHOUSE_CONSUMPTION_LIST_SK,
  },
  {
    path: '/shops',
    element: <ShopList />,
    permission: SHOP_LIST_SK,
  },
  {
    path: '/suppliers',
    element: <SupplierList />,
    permission: SUPPLIER_LIST_SK,
  },
  {
    path: '/internal-transfers',
    element: <InternalTransferList />,
    permission: INTERNAL_TRANSFER_LIST_SK,
  },
  {
    path: '/internal-transfers/create',
    element: <CreateUpdateInternalTransfer />,
    permission: INTERNAL_TRANSFER_CREATE_SK,
  },
  {
    path: '/internal-transfers/edit/:id',
    element: <CreateUpdateInternalTransfer />,
    permission: INTERNAL_TRANSFER_EDIT_SK,
  },
  {
    path: '/internal-transfers/:id',
    element: <InternalTransferDetail />,
    permission: INTERNAL_TRANSFER_VIEW_SK,
  },
  {
    path: '/stock-requests',
    element: <StockRequestList />,
    permission: STOCK_REQUEST_LIST_SK,
  },
  {
    path: '/stock-requests/create',
    element: <CreateUpdateStockRequest />,
    permission: STOCK_REQUEST_CREATE_SK,
  },
  {
    path: '/stock-requests/:id/edit',
    element: <CreateUpdateStockRequest />,
    permission: STOCK_REQUEST_EDIT_SK,
  },
  {
    path: '/stock-requests/:id',
    element: <StockRequestDetail />,
    permission: STOCK_REQUEST_VIEW_SK,
  },
  {
    path: '/warehouse-orders',
    element: <WarehouseOrderList />,
    permission: WAREHOUSE_ORDER_LIST_SK,
  },
  {
    path: '/warehouse-orders/create',
    element: <CreateUpdateWarehouseOrder />,
    permission: WAREHOUSE_ORDER_CREATE_SK,
  },
  {
    path: '/warehouse-orders/:id/edit',
    element: <CreateUpdateWarehouseOrder />,
    permission: WAREHOUSE_ORDER_UPDATE_SK,
  },
  {
    path: '/warehouse-orders/:id',
    element: <WarehouseOrderDetail />,
    permission: WAREHOUSE_ORDER_VIEW_SK,
  },
  {
    path: '/purchases',
    element: <PurchaseList />,
    permission: PURCHASE_LIST_SK,
  },
  {
    path: '/purchases/form',
    element: <CreatePurchase />,
    permission: PURCHASE_CREATE_SK,
  },
  {
    path: '/purchases/form/:id',
    element: <CreatePurchase />,
    permission: PURCHASE_EDIT_SK,
  },
  {
    path: '/purchases/:id',
    element: <PurchaseDetail />,
    permission: PURCHASE_VIEW_SK,
  },
  {
    path: '/bills',
    element: <BillList />,
    permission: BILL_LIST_SK,
  },
  {
    path: '/expenses',
    element: <ExpenseList />,
    permission: EXPENSE_LIST_SK,
  },
  {
    path: '/expense-headers',
    element: <ExpenseHeaderList />,
    permission: EXPENSE_HEADER_LIST_SK,
  },
  {
    path: '/expense-subheaders',
    element: <ExpenseSubheaderList />,
    permission: EXPENSE_SUBHEADER_LIST_SK,
  },
  {
    path: '/bills/unpaid/:id',
    element: <BillDetail />,
    permission: BILL_VIEW_SK,
  },
  {
    path: '/bills/paid/:id',
    element: <BillDetail />,
    permission: BILL_VIEW_SK,
  },
  {
    path: '/bills/paid',
    element: <PaidBillList />,
    permission: BILL_LIST_SK,
  },
  {
    path: '/bills/unpaid',
    element: <UnpaidBillList />,
    permission: BILL_LIST_SK,
  },
  {
    path: '/bills/form',
    element: <CreateBill />,
    permission: BILL_CREATE_SK,
  },
  {
    path: '/bills/unpaid/form/:id',
    element: <CreateBill />,
    permission: BILL_EDIT_SK,
  },
  {
    path: '/payments',
    element: <PaymentList />,
    permission: PAYMENT_LIST_SK,
  },
  {
    path: '/payments/:id',
    element: <PaymentDetail />,
    permission: PAYMENT_VIEW_SK,
  },
  {
    path: '/payments/form',
    element: <CreatePayment />,
    permission: PAYMENT_CREATE_SK,
  },
  {
    path: '/payments/form/:id',
    element: <CreatePayment />,
    permission: PAYMENT_EDIT_SK,
  },
  {
    path: '/payments/single-form',
    element: <SinglePayment />,
    permission: PAYMENT_CREATE_SK,
  },
  {
    path: '/payments/single-form/:id',
    element: <SinglePayment />,
    permission: PAYMENT_EDIT_SK,
  },
  {
    path: '/payments/bulk-form',
    element: <BulkPayment />,
    permission: PAYMENT_CREATE_SK,
  },
  {
    path: '/uoms',
    element: <UomList />,
    permission: UOM_LIST_SK,
  },
  {
    path: '/banks',
    element: <BankList />,
    permission: BANK_LIST_SK,
  },
  {
    path: '/inventories',
    element: <InventoryList />,
    permission: INVENTORY_LIST_SK,
  },
  {
    path: '/inventories/:id',
    element: <InventoryHistory />,
    permission: INVENTORY_VIEW_SK,
  },
  {
    path: '/stock-list',
    element: <StockListView />,
    permission: INVENTORY_LIST_SK,
  },
  {
    path: '/stock-movements',
    element: <StockMovementList />,
    permission: STOCK_MOVEMENT_LIST_SK
  },
  {
    path: '/orders',
    element: <OrderList />,
    permission: ORDER_LIST_SK
  },
  {
    path: '/orders/:id',
    element: <OrderDetails />,
    permission: ORDER_VIEW_SK,
  },
  {
    path: '/orders/order-fulfillment-status',
    element: <OrderFulfillmentStatus />,
    permission: ORDER_LIST_SK,
  },
  {
    path: '/orders/edit/:id',
    element: <CreateUpdateOrder />,
    permission: ORDER_ITEM_EDIT_SK,
  },
  {
    path: '/sales',
    element: <SaleList />,
    permission: SALE_LIST_SK
  },
  {
    path: '/sales/:id',
    element: <SaleDetails />,
    permission: SALE_VIEW_SK
  },
  {
    path: '/stock-returns',
    element: <StockReturnList />,
    permission: STOCK_RETURN_LIST_SK
  },
  {
    path: '/reports/sales',
    element: <SalesPivotReport />,
    permission: SALE_REPORT_LIST_SK
  },
  // {
  //   path: '/reports/sales-pivot',
  //   element: <SalesPivotReport />,
  //   permission: SALE_REPORT_LIST_SK
  // },
  // {
  //   path: '/reports/orders',
  //   element: <OrderReport />,
  //   permission: ORDER_REPORT_LIST_SK
  // },
  {
    path: '/reports/orders',
    element: <OrderPivotReport />,
    permission: ORDER_REPORT_LIST_SK
  },
  {
    path: '/reports/purchase-pivot',
    element: <PurchasePivotReport />,
    permission: PURCHASE_REPORT_LIST_SK
  },
  {
    path: '/reports/bills-pivot',
    element: <BillsPivotReport />,
    permission: BILL_REPORT_LIST_SK
  },
  {
    path: '/reports/payments-made',
    element: <PaymentsMadeReport />,
    permission: PAYMENT_REPORT_LIST_SK
  },
  {
    path: '/reports/stock-movement-pivot',
    element: <StockMovementPivotReport />,
    permission: STOCK_MOVEMENT_REPORT_LIST_SK
  },
  {
    path: '/reports/stock-pivot',
    element: <StockPivotReport />,
    permission: STOCK_MOVEMENT_REPORT_LIST_SK
  },
  {
    path: '/reports/stock-order-summary',
    element: <StockOrderSummaryReport />,
    permission: STOCK_ORDER_SUMMARY_REPORT_LIST_SK
  },
  {
    path: '/reports/daily-stock-summary',
    element: <DailyStockSummaryReport />,
    permission: DAILY_STOCK_SUMMARY_REPORT_LIST_SK
  },
  {
    path: '/reports/daily-inventory-valuation',
    element: <DailyInventoryValuationReport />,
    permission: DAILY_INVENTORY_VALUATION_REPORT_LIST_SK,
  },
  {
    path: '/reports/estimated-production-balance',
    element: <EstimatedProductionBalanceReport />,
    permission: ESTIMATED_PRODUCTION_BALANCE_REPORT_LIST_SK
  },
  {
    path: '/purchase-history',
    element: <PurchaseHistory />,
    permission: PURCHASE_HISTORY_LIST_SK,
  },

  {
    path: '/pages/account-setting',
    element: <AccountSetting />,
    permission: null,
  },
  {
    path: '/stock-adjustments',
    element: <StockAdjustmentList />,
    permission: STOCK_ADJUSTMENT_LIST_SK
  },
  {
    path: '/brands',
    element: <BrandList />,
    permission: BRAND_LIST_SK
  },
  {
    path: '/regions',
    element: <RegionList />,
    permission: REGION_LIST_SK
  },
  {
    path: '/orders/create',
    element: <CreateUpdateOrder />,
    permission: ORDER_CREATE_SK
  },
  {
    path: '/discrepancies',
    element: <DiscrepancySummaryView />,
    permission: ORDER_LIST_SK
  },
  {
    path: '/discrepancies/:sku',
    element: <DiscrepancyList />,
    permission: ORDER_LIST_SK
  },
  {
    path: '/backorders',
    element: <BackorderListByShop />,
    permission: ORDER_LIST_SK
  },
  {
    path: '/shop-balance',
    element: <ShopBalanceListByShopView />,
    permission: ORDER_LIST_SK
  },
  {
    path: '/permission-denied',
    element: <PermissionDenied />,
    permission: null,
  },
  {
    path: '/par-levels',
    element: <ParLevelSettingsPage />,
    permission: PAR_LEVEL_LIST_SK,
  },
  { path: '*', element: <Navigate to="/404" />, permission: null },
];
